import "./styles.scss";

import { Breadcrumbs, Button, Form, Page } from "components";
import { useState, useCallback } from "react";
import { CSVReader } from "./components/CSVReader";
import { accountsAPI } from "services/accounts";
import _ from "lodash";
import Swal from "sweetalert2";
import { inhabitantsAPI } from "services/inhabitantsAPI";
import { Link } from "react-router-dom";

export default function TransferWallet() {
  const [loading, setLoading] = useState(false);
  const [cpfList, setCpfList] = useState([]);
  const [assessorPrimaryOptions, setAssessorPrimaryOptions] = useState([]);
  const [assessorSecondaryOptions, setAssessorSecondaryOptions] = useState([]);
  const [selectedAssessorPrimary, setSelectedAssessorPrimary] = useState(null);
  const [selectedAssessorSecondary, setSelectedAssessorSecondary] =
    useState(null);

  const breadcrumbs = [
    { name: "Home", to: "/" },
    { name: "PRO", to: "/pro" },
    { name: "Transferência Carteira Clientes", to: "" },
  ];

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    if (!selectedAssessorPrimary || !selectedAssessorSecondary) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Selecione os assessores!",
      });

      setLoading(false);
      return;
    }

    const payload = {
      documents: cpfList,
      from: {
        inhabitant_id: selectedAssessorPrimary.value,
        ldap: selectedAssessorPrimary.label,
      },
      to: {
        inhabitant_id: selectedAssessorSecondary.value,
        ldap: selectedAssessorSecondary.label,
      },
      user: {
        inhabitantId: selectedAssessorPrimary.value,
        ldap: selectedAssessorPrimary.label,
      },
    };

    inhabitantsAPI
      .post("/user/inhabitants/segments/bulk-transfer", payload)
      .then(({ data }) => {
        setCpfList([]);
        setSelectedAssessorPrimary(null);
        setSelectedAssessorSecondary(null);
        Swal.fire({
          icon: "success",
          title: `${data.inhabitantsTransferredCount} cliente(s) transferido(s)`,
          text: "Os dados foram transferidos com sucesso!",
        });
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data?.error ?? "Erro desconhecido",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const findAssessor = async (searchTerm, setOptions) => {
    try {
      const response = await accountsAPI.get("/auth/users", {
        params: {
          search: searchTerm,
        },
      });

      const options = response.data.map((user) => ({
        label: `${user.ldap} ${user.name ? `(${user.name})` : ""}`,
        value: user.user_id,
      }));

      setOptions(options);
    } catch (error) {
      console.error(error);
    }
  };

  const debouncedFindAssessorPrimary = useCallback(
    _.debounce(
      (searchTerm) => findAssessor(searchTerm, setAssessorPrimaryOptions),
      300
    ),
    []
  );
  const debouncedFindAssessorSecondary = useCallback(
    _.debounce(
      (searchTerm) => findAssessor(searchTerm, setAssessorSecondaryOptions),
      300
    ),
    []
  );

  const handleFindAssessorPrimary = (inputValue) => {
    debouncedFindAssessorPrimary(inputValue);
  };

  const handleFindAssessorSecondary = (inputValue) => {
    debouncedFindAssessorSecondary(inputValue);
  };

  const handleSelectAssessorPrimary = (selectedOption) => {
    setSelectedAssessorPrimary(selectedOption);
  };

  const handleSelectAssessorSecondary = (selectedOption) => {
    setSelectedAssessorSecondary(selectedOption);
  };

  const handleLoadCSV = (event) => {
    const cpfs = event.map((item) => item.cpf);

    for (const cpf of cpfs) {
      if (cpf.length !== 11) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `CPF inválido: ${cpf}, tente novamente!`,
        });
        return;
      }
    }

    setCpfList(cpfs);
  };

  return (
    <>
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form className="container-form-tranfer-wallet" onSubmit={handleSubmit}>
          <Page.Title>Transferência Carteira Clientes</Page.Title>

          <Form.Field className="field-select col-md-5">
            <Form.Label>Assessor(a)</Form.Label>
            <div className="row">
              <div className="col-md-12">
                <Form.Select
                  placeholder="Procure por assessor"
                  noOptionsMessage={() => "Digite o nome ou LDAP"}
                  options={assessorPrimaryOptions}
                  onInputChange={handleFindAssessorPrimary}
                  onChange={handleSelectAssessorPrimary}
                  value={selectedAssessorPrimary}
                />
              </div>
            </div>
          </Form.Field>

          <Form.Field className="field-select col-md-5">
            <Form.Label>Alterar para Assessor(a)</Form.Label>
            <div className="row">
              <div className="col-md-12">
                <Form.Select
                  placeholder="Procure por assessor"
                  noOptionsMessage={() => "Digite o nome ou LDAP"}
                  options={assessorSecondaryOptions}
                  onInputChange={handleFindAssessorSecondary}
                  onChange={handleSelectAssessorSecondary}
                  value={selectedAssessorSecondary}
                />
              </div>
            </div>
          </Form.Field>

          <Form.Field className="field-select col-md-5">
            <Form.Label>Lista de clientes</Form.Label>
            <div className="csv-file-cpf">
              <CSVReader onFileLoaded={handleLoadCSV} />
              <a href="/assets/downloads/transfer-wallet.csv">
                Baixar modelo do arquivo de importação.
              </a>
              <small>
                <strong>OBS</strong>: Necessário o envio do CPF considerando{" "}
                <strong>11</strong> dígitos!
                <br />
                Exemplo: 99999999999 ou 999.999.999-99
              </small>
            </div>
          </Form.Field>

          <Form.Field>
            <div className="buttons">
              <Link to="/pro" className="button-cancel">
                Cancelar
              </Link>

              <Button className="save-btn" type="submit" disabled={loading}>
                {loading ? "Enviando aguarde..." : "Transferir"}
              </Button>
            </div>
          </Form.Field>
        </Form>
      </Page>
    </>
  );
}
